import "./viewFlight.css";
import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import { TbEdit } from "react-icons/tb";
import AddAircraftModal from "../../../components/Modal/AddAircraftModal";
import AddFlightModal from "../../../components/Modal/AddFlightModal";
import AddFlightManual from "../../../components/Modal/AddFlightManual";
import LayoutProvider from "../../../providers/LayoutProvider";
import { getFlightbyId } from "../../../components/Axios/Axios";
import { useParams } from "react-router-dom";

function ViewFlight() {
  const [refresh, setRefresh] = useState(0);
  const { flightId } = useParams<{ flightId: any }>();
  const [showNestedList, setShowNestedList] = React.useState(false);
  const [aircraftNestedList, setAircraftNestedList] = React.useState(false);
  const [addFlight, setAddFlight] = React.useState(false);
  const [addAircraft, setAddAircraft] = React.useState(false);
  const [userName, setUserName] = React.useState("");
  const [id, setId] = React.useState("");
  const [flightData, setFlightData] = React.useState<any>([]);

  const [isAutoModalOpen, setIsAutoModalOpen] = React.useState(false);
  const [isManualModalOpen, setIsManualModalOpen] = React.useState(false);
  console.log(flightId)
  const handleOpenAuto = () => {
    setIsAutoModalOpen(true);
    setIsManualModalOpen(false);
  };

  const handleOpenManual = () => {
    setIsAutoModalOpen(false);
    setIsManualModalOpen(true);
  };

  const handleCloseAuto = () => {
    setIsAutoModalOpen(false);
  };

  const handleCloseManual = () => {
    setIsManualModalOpen(false);
  };

  const handleAddFlight = () => {
    setAddFlight(true);
    setIsAutoModalOpen(true);
  };

  const handleCloseFlight = () => {
    setAddFlight(false);
  };

  const handleAddAircraft = () => {
    setAddAircraft(true);
  };

  const handleCloseAircraft = () => {
    setAddAircraft(false);
  };

  const handleToggleAircraftList = () => {
    setAircraftNestedList(!aircraftNestedList);
  };

  const handleToggleNestedList = () => {
    setShowNestedList(!showNestedList);
  };



  React.useEffect(() => {
    if (flightId) {
      async function fetchFlightData() {
        try {
          // Make an API request using flightId
          const response = await getFlightbyId(flightId);
          // const data=response;
          // Store the fetched data in a state variable
          setFlightData(response);
          console.log("body1", response)
        } catch (error) {
          console.error("Error fetching flight data:", error);
        }
      }

      // Call the function to fetch flight data
      fetchFlightData();
    }
  }, [flightId]);



  return (
    <LayoutProvider>
      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h4 className="dashboard_heading">Flight: {flightData?.flightNumber || "-"}</h4>
        <h6 className="dashboard_subheading">
        </h6>
      </section>
      <section className="btn_container">
        <button className="button heading4">
          <TbEdit /> Edit Flight
        </button>
        <section style={{ display: "flex", gap: "15px" }}>
          <button className="button heading4"onClick={handleOpenAuto}>
            <BsPlusLg /> Add Flight
          </button>
          {isAutoModalOpen && (

            <AddFlightModal
              open={isAutoModalOpen}
              onCloseFm={handleCloseAuto}
              onOpenManual={handleOpenManual}
            />
          )}

          {isManualModalOpen && (
            <AddFlightManual
              open={isManualModalOpen}
              onCloseFm={handleCloseManual}
              onOpenAuto={handleOpenAuto}
            />
          )}
          <button className="button b_g heading4" onClick={handleAddAircraft}>
            <BsPlusLg /> Add Aircraft
          </button>
          <AddAircraftModal
            open={addAircraft}
            onClose={handleCloseAircraft}
          />
        </section>
      </section>
      <div
        className="div_container"
        style={{ marginTop: "2%", padding: "30px" }}
      >
        <div>
          <div style={{ display: "flex", gap: "2%" }}>
            <section className="flight_sections">
              <h3 className="flight_heading secondary">FLIGHT DETAILS</h3>
              <div className="flight_details">
                <section>
                  <p className="flight_subheading">Flight Number</p>
                  <p className="flight_subheading">Date</p>
                  <p className="flight_subheading">Aircraft</p>
                  <p className="flight_subheading">In (UTC)</p>
                  <p className="flight_subheading">Out (URC)</p>
                </section>
                <section>
                  <p className="flight_subheading">{flightData?.flightNumber || "-"} </p>
                  <p className="flight_subheading">{flightData?.flightDate || "-"}</p>
                  <p className="flight_subheading">{flightData?.aircraft?.model || "-"}</p>
                  <p className="flight_subheading">{flightData?.times?.actual_in || "-"}</p>
                  <p className="flight_subheading">{flightData?.times?.actual_out || "-"}</p>
                </section>
              </div>
            </section>
            <section className="flight_sections">
              <h3 className="flight_heading secondary">TIME</h3>
              <div className="flight_details">
                <section>
                  <p className="flight_subheading">Total Time</p>
                  <p className="flight_subheading">Day</p>
                  <p className="flight_subheading">Night</p>
                  <p className="flight_subheading">Total Landings</p>
                </section>
                <section>
                  <p className="flight_subheading">{flightData?.times?.totalTime || 0} </p>
                  <p className="flight_subheading">{flightData?.times?.day || 0}</p>
                  <p className="flight_subheading">{flightData?.times?.night || 0}</p>
                  <p className="flight_subheading">{flightData?.landingsAndApproaches?.totalLandings || 0}</p>
                </section>
              </div>
            </section>
          </div>

          <div style={{ display: "flex", gap: "2%" }}>
            <section className="flight_sections" style={{ marginTop: "2%" }}>
              <h3 className="flight_heading secondary">Duty</h3>
              <div className="flight_details">
                <section>
                  <p className="flight_subheading">On Duty (UTC)</p>
                  <p className="flight_subheading">Off Duty (UTC)</p>
                </section>
                <section>
                  <p className="flight_subheading">{flightData?.times?.actual_on || "-"}</p>
                 <p className="flight_subheading">{flightData?.times?.actual_off || "-"}</p>
                </section>
              </div>
            </section>
            <section className="flight_sections" style={{ marginTop: "2%" }}>
              <h3 className="flight_heading secondary">OPERATIONS</h3>
              <div className="flight_details">
                <section>
                  {/* <p className="flight_subheading">Daul Recieved</p> */}
                  <p className="flight_subheading">PIC</p>
                  <p className="flight_subheading">SIC</p>
                  <p className="flight_subheading">IP</p>
                  <p className="flight_subheading">EP</p>
                </section>
                <section>
                <p className="flight_subheading">{flightData?.times?.pic || 0}</p>
                <p className="flight_subheading">{flightData?.times?.sic || 0}</p>
                <p className="flight_subheading">{flightData?.times?.ip || 0}</p>
                <p className="flight_subheading">{flightData?.times?.ep || 0}</p>
                  {/* <p className="flight_subheading">ABC</p> */}
                </section>
              </div>
            </section>
          </div>

        </div>

      </div>
    </LayoutProvider>
  );
}

export default ViewFlight;


